module.exports = __webpack_public_path__ + "static/media/puzzle.b5fac2be.svg";